import { render } from "./Result.vue.js?vue&type=template&id=2ec56613!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./Result.vue?vue&type=template&id=2ec56613"
import script from "./Result.vue.js?vue&type=script&lang=js!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue.js?vue&type=script&lang=js!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./Result.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__